export default __webpack_public_path__ + "static/media/report_load.3e920081.gif";